/* CREU · Buscador (Alba, 21-10-2026). Formato St. Agni: total real de resultados,
   "Ver todos" a la derecha, rejilla de 4 y sin capa gris sobre la página.
   Antes iba en línea en layout/theme.liquid y pedía /search/suggest.json con
   resources[limit]=8 (la búsqueda predictiva de Shopify no da más de 10). */
(function () {
  var bar = document.getElementById('creu-search');
  if (!bar) return;
  var input = document.getElementById('creu-search-input');
  var results = document.getElementById('creu-search-results');
  var grid = document.getElementById('creu-search-grid');
  var countEl = document.getElementById('creu-search-count');
  var allLink = document.getElementById('creu-search-all');
  var overlay = bar.querySelector('.creu-search-bar__overlay');
  var closeBtn = bar.querySelector('.creu-search-bar__close');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer, controller;

  function searchUrl(q) {
    return root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
  }
  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function clear() {
    results.classList.remove('creu-search-bar__results--visible');
    grid.innerHTML = '';
    countEl.textContent = '';
  }
  function openSearch() {
    var header = document.querySelector('#shopify-section-header, [id*="shopify-section-header"]');
    if (header) document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    /* El buscador se fija justo bajo el encabezado, esté donde esté la clienta en la página,
       con una capa blanca desde ahí hacia abajo: el encabezado se ve tal cual y la página no asoma. */
    var hd = document.querySelector('header');
    var top = hd ? Math.max(0, Math.round(hd.getBoundingClientRect().bottom)) : 0;
    bar.style.top = top + 'px';
    overlay.style.top = top + 'px';
    bar.classList.add('creu-search-bar--open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      /* Si el buscador original del tema llega a abrirse, se cierra: si no, se queda el cursor. */
      var d = document.querySelector('#search-modal dialog');
      if (d && d.open) d.close();
      input.focus();
    }, 100);
  }
  function closeSearch() {
    bar.classList.remove('creu-search-bar--open');
    document.body.style.overflow = '';
    input.value = '';
    clear();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.search-modal__button, [on\\:click*="search-modal"]');
    if (btn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openSearch();
    }
  }, true);

  closeBtn.addEventListener('click', closeSearch);
  overlay.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && bar.classList.contains('creu-search-bar--open')) closeSearch();
  });

  input.addEventListener('keydown', function (e) {
    var q = input.value.trim();
    if (e.key === 'Enter' && q) window.location.href = searchUrl(q);
  });

  /* El panel de resultados llega hasta el final de la pantalla: no asoma la página de debajo. */
  function fit() {
    var h = window.innerHeight - results.getBoundingClientRect().top;
    if (h > 200) { results.style.height = h + 'px'; results.style.maxHeight = h + 'px'; }
  }
  window.addEventListener('resize', function () {
    if (results.classList.contains('creu-search-bar__results--visible')) fit();
  });

  /* Piezas con gemela (oro / plata son dos productos en Shopify): se enseña solo la del
     acabado elegido por la clienta (window.CreuFinish), y solo si la gemela también ha
     salido en la búsqueda. Las piezas que existen en un solo acabado se enseñan siempre. */
  var MAX_PAGES = 10;
  function finishOf(mat) {
    var m = String(mat || '').toLowerCase();
    if (/plata|rodio|silver/.test(m)) return 'rodio';
    if (/oro|dorad|gold/.test(m)) return 'oro';
    return null;
  }
  function oneFinish(list, forced) {
    var current = forced || (window.CreuFinish && window.CreuFinish.get && window.CreuFinish.get()) || 'oro';
    var handles = {};
    list.forEach(function (p) { handles[p.handle] = true; });
    var seen = {};
    return list.filter(function (p) {
      if (seen[p.handle]) return false;
      seen[p.handle] = true;
      var f = finishOf(p.mat);
      return !(p.twin && handles[p.twin] && f && f !== current);
    });
  }

  /* Búsqueda acotada (21-10-2026): cada palabra que escribe la clienta tiene que cumplirse.
     Shopify ordena por relevancia pero no descarta nada ("anillo perla" daba 645 piezas).
     · Palabras de categoría (anillo, collar…) → solo en nombre + categoría de la pieza, para
       que un pendiente "combinable con collares" no salga al buscar "collar".
     · El resto → en nombre, categoría, material, opciones y descripción.
     · EQUIV: equivalencias (perla = pearl = nácar…). Se amplían aquí cuando haga falta.
     · Palabras de 4 letras o menos casan con el principio de una palabra ("aro" → "aros",
       no "claro"); las más largas, en cualquier parte ("pearl" → "Tripearl"). */
  var CATEGORIAS = {
    anillo: ['anillo', 'ring'],
    collar: ['collar', 'choker', 'colgante', 'cadena', 'necklace'],
    colgante: ['colgante', 'pendant'],
    cadena: ['cadena', 'chain'],
    choker: ['choker'],
    pendiente: ['pendiente', 'earring', 'ear cuff'],
    piercing: ['piercing'],
    pulsera: ['pulsera', 'bracelet'],
    tobillera: ['tobillera', 'anklet'],
    charm: ['charm']
  };
  var EQUIV = {
    perla: ['perl', 'pearl', 'nacar'],
    nacar: ['nacar', 'perl', 'pearl'],
    aro: ['aro', 'hoop', 'click'],
    circonita: ['circon', 'zircon', 'cz', 'brill'],
    brillo: ['brill', 'circon', 'zircon', 'shiny'],
    piedra: ['piedra', 'stone', 'jade', 'turquesa', 'amatista', 'cuarzo', 'agata'],
    acero: ['acero', 'steel'],
    estrella: ['estrell', 'star'],
    luna: ['luna', 'moon'],
    sol: ['sol', 'sun'],
    corazon: ['corazon', 'heart'],
    mariposa: ['mariposa', 'butterfly'],
    concha: ['concha', 'shell', 'caracol'],
    letra: ['letra', 'inicial'],
    inicial: ['inicial', 'letra']
  };
  /* Oro y plata son ACABADO, no texto: casi todas las descripciones dicen "plata 925 con baño
     de oro". Se comparan con el material de la pieza (blwe.material) y mandan sobre la
     preferencia de acabado de la clienta mientras dure esa búsqueda. */
  var ACABADOS = { plata: 'rodio', rodio: 'rodio', silver: 'rodio', plateado: 'rodio', plateada: 'rodio', oro: 'oro', dorado: 'oro', dorada: 'oro', gold: 'oro' };
  var VACIAS = { de: 1, del: 1, con: 1, en: 1, y: 1, e: 1, para: 1, el: 1, la: 1, los: 1, las: 1, un: 1, una: 1, the: 1, and: 1, with: 1, 'for': 1 };

  function norm(t) {
    return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function singular(w) {
    var known = function (x) { return CATEGORIAS[x] || EQUIV[x]; };
    if (known(w)) return w;
    if (/s$/.test(w) && known(w.slice(0, -1))) return w.slice(0, -1);   /* anillos, pendientes, perlas */
    if (/es$/.test(w) && known(w.slice(0, -2))) return w.slice(0, -2);  /* collares, corazones */
    if (w.length > 3 && /s$/.test(w)) return w.slice(0, -1);
    return w;
  }
  /* Convierte la búsqueda en una lista de condiciones: cada una es { formas, soloCabecera }. */
  function terms(q) {
    return norm(q).split(' ').filter(function (w) { return w.length > 1 && !VACIAS[w]; }).map(function (w) {
      var base = singular(w);
      if (ACABADOS[w] || ACABADOS[base]) return { acabado: ACABADOS[w] || ACABADOS[base] };
      var cat = CATEGORIAS[base] || CATEGORIAS[w];
      if (cat) return { formas: cat, soloCabecera: true };
      var formas = (EQUIV[base] || EQUIV[w] || []).concat([w, base]);
      return { formas: formas, soloCabecera: false };
    });
  }
  function hit(texto, forma) {
    if (forma.length >= 5) return texto.indexOf(forma) >= 0;
    return (' ' + texto).indexOf(' ' + forma) >= 0;
  }
  function finishWanted(conds) {
    for (var i = 0; i < conds.length; i++) if (conds[i].acabado) return conds[i].acabado;
    return null;
  }
  function matches(conds, head, body, mat) {
    if (!conds.length) return true;
    var h = norm(head), b = norm(body);
    return conds.every(function (c) {
      if (c.acabado) return finishOf(mat) === c.acabado;
      return c.formas.some(function (f) { return hit(h, f) || (!c.soloCabecera && hit(b, f)); });
    });
  }
  function narrow(list, q) {
    var conds = terms(q);
    return oneFinish(list.filter(function (p) { return matches(conds, p.head, p.body, p.mat); }), finishWanted(conds));
  }

  function card(p) {
    var price = (p.varies ? '<span class="creu-search-bar__from">desde</span>' : '') + euros(p.price);
    if (p.compare) price += '<s>' + euros(p.compare) + '</s>';
    return '<a href="' + esc(p.url) + '" class="creu-search-bar__result-item">' +
      (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<span class="creu-search-bar__noimg"></span>') +
      '<div class="creu-search-bar__result-title">' + esc(p.title) + '</div>' +
      '<div class="creu-search-bar__result-price">' + price + '</div>' +
      '</a>';
  }

  /* Página de búsqueda ("Ver todos"): se esconden las tarjetas que no cumplen todas las
     palabras, y el número de la cabecera cuenta solo las que sí (y cada pieza una vez). */
  var spCount = document.querySelector('[data-creu-sp-count]');
  if (spCount && spCount.dataset.q) {
    var sq = spCount.dataset.q, en = spCount.dataset.en === 'true';
    var spConds = terms(sq);
    var spFin = finishWanted(spConds);
    /* Si la búsqueda nombra un acabado, manda él (y no la preferencia de la clienta). */
    if (spFin) document.documentElement.classList.add('creu-sp-fin');
    var markCards = function () {
      document.querySelectorAll('.product-grid__item[data-creu-head]').forEach(function (li) {
        li.classList.toggle('creu-sp-out', !matches(spConds, li.dataset.creuHead, li.dataset.creuBody, li.dataset.creuMatraw));
      });
    };
    markCards();
    new MutationObserver(markCards).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });

    var spPage = function (n) {
      return fetch(searchUrl(sq) + '&view=creu-json&page=' + n)
        .then(function (r) { return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    };
    spPage(1).then(function (first) {
      var pages = Math.min(first.pages || 1, MAX_PAGES);
      var rest = [];
      for (var n = 2; n <= pages; n++) rest.push(spPage(n));
      return Promise.all(rest).then(function (more) {
        var all = first.products || [];
        more.forEach(function (d) { all = all.concat(d.products || []); });
        var total = narrow(all, sq).length;
        var word = en ? (total === 1 ? 'result' : 'results') + ' for' : (total === 1 ? 'resultado' : 'resultados') + ' para';
        spCount.textContent = total + ' ' + word + ' "' + sq + '"';
        /* El título de la pestaña también cuenta cada pieza una sola vez. */
        document.title = (en ? 'Search: ' : 'Búsqueda: ') + total + ' ' + word + ' "' + sq + '" – CREU';
      });
    }).catch(function () {});
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (!q) { clear(); return; }

    timer = setTimeout(function () {
      if (controller) controller.abort();
      controller = new AbortController();
      var signal = controller.signal;
      function page(n) {
        return fetch(searchUrl(q) + '&view=creu-json&page=' + n, { signal: signal })
          .then(function (r) { return r.text(); })
          .then(function (t) { return JSON.parse(t); });
      }
      /* La primera página se pinta al momento. Si hay más (hasta 10 = 480 piezas), se piden
         todas a la vez y se vuelve a pintar acotado, con las gemelas quitadas y el número exacto.
         Shopify pone primero lo más relevante, así que con 10 páginas basta para acotar. */
      function paint(list) {
        var products = narrow(list, q);
        var total = products.length;
        allLink.href = searchUrl(q);
        allLink.hidden = !products.length;
        countEl.textContent = products.length
          ? total + ' resultado' + (total !== 1 ? 's' : '')
          : 'Sin resultados';
        grid.innerHTML = products.map(card).join('');
        results.classList.add('creu-search-bar__results--visible');
        fit();
        return products;
      }
      page(1)
        .then(function (first) {
          var pages = Math.min(first.pages || 1, MAX_PAGES);
          paint(first.products || []);
          results.scrollTop = 0;
          if (pages === 1) return;
          var rest = [];
          for (var n = 2; n <= pages; n++) rest.push(page(n));
          return Promise.all(rest).then(function (more) {
            var all = first.products || [];
            more.forEach(function (d) { all = all.concat(d.products || []); });
            var scroll = results.scrollTop;
            paint(all);
            results.scrollTop = scroll;
          });
        })
        .catch(function () {});
    }, 250);
  });
})();
